import {
  getByTableName,
  saveWebTableColumns,
  getAll,
  getDetail,
  deleteObj,
  getMyAll,
} from '@/api/webtablecolumnsserv'

export default {
  state: {
    state_WebTableColumns_GetByTableNameResult: null,
    state_WebTableColumns_SaveWebTableColumnsResult: null,
    state_WebTableColumns_GetAllResult: null,
    state_WebTableColumns_GetDetailResult: null,
    state_WebTableColumns_DeleteObjResult: null,
    state_WebTableColumns_GetMyAllResult: null,
  },
  mutations: {
    SET_WEBTABLECOLUMNS_GETBYTABLENAME_RESULT: (state, rst) => {
      state.state_WebTableColumns_GetByTableNameResult = rst;
    },
    SET_WEBTABLECOLUMNS_SAVEWEBTABLECOLUMNS_RESULT: (state, rst) => {
      state.state_WebTableColumns_SaveWebTableColumnsResult = rst;
    },
    SET_WEBTABLECOLUMNS_GETALL_RESULT: (state, rst) => {
      state.state_WebTableColumns_GetAllResult = rst;
    },
    SET_WEBTABLECOLUMNS_GETDETAIL_RESULT: (state, rst) => {
      state.state_WebTableColumns_GetDetailResult = rst;
    },
    SET_WEBTABLECOLUMNS_DELETEOBJ_RESULT: (state, rst) => {
      state.state_WebTableColumns_DeleteObjResult = rst;
    },
    SET_WEBTABLECOLUMNS_GETMYALL_RESULT: (state, rst) => {
      state.state_WebTableColumns_GetMyAllResult = rst;
    },
  },
  actions: {
    WebTableColumnsServ_GetByTableName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getByTableName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WEBTABLECOLUMNS_GETBYTABLENAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WEBTABLECOLUMNS_GETBYTABLENAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WebTableColumnsServ_SaveWebTableColumns({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        saveWebTableColumns(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WEBTABLECOLUMNS_SAVEWEBTABLECOLUMNS_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WEBTABLECOLUMNS_SAVEWEBTABLECOLUMNS_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WebTableColumnsServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WEBTABLECOLUMNS_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WEBTABLECOLUMNS_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WebTableColumnsServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WEBTABLECOLUMNS_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WEBTABLECOLUMNS_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WebTableColumnsServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WEBTABLECOLUMNS_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WEBTABLECOLUMNS_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    WebTableColumnsServ_GetMyAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_WEBTABLECOLUMNS_GETMYALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_WEBTABLECOLUMNS_GETMYALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_WebTableColumns_GetByTableNameResult: state => {
      return state.state_WebTableColumns_GetByTableNameResult;
    },
    get_WebTableColumns_SaveWebTableColumnsResult: state => {
      return state.state_WebTableColumns_SaveWebTableColumnsResult;
    },
    get_WebTableColumns_GetAllResult: state => {
      return state.state_WebTableColumns_GetAllResult;
    },
    get_WebTableColumns_GetDetailResult: state => {
      return state.state_WebTableColumns_GetDetailResult;
    },
    get_WebTableColumns_DeleteObjResult: state => {
      return state.state_WebTableColumns_DeleteObjResult;
    },
    get_WebTableColumns_GetMyAllResult: state => {
      return state.state_WebTableColumns_GetMyAllResult;
    },
  }
}